import React, { DetailedHTMLProps, InputHTMLAttributes } from "react";

import { FieldError } from "react-hook-form";

type InputProps = {
  label?: string;
  error?: FieldError;
  type?: "text" | "email" | "password" | "number";
} & Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  "type"
>;

// MIGRATE: WOMBAT UI
const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, type = "text", error = {}, ...props }, ref) => {
    return (
      <div>
        {label && (
          <label className="block text-sm font-medium leading-5 text-gray-700">
            {label}
          </label>
        )}
        <div className="relative rounded-md shadow-sm">
          <input
            {...props}
            type={type}
            ref={ref}
            className={`block w-full transition duration-150 ease-in-out form-input sm:text-sm sm:leading-5 ${
              error?.message
                ? "border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red"
                : "focus:shadow-outline-primary focus:border-primary-300"
            }`}
          />
          {error?.message && (
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <svg
                className="w-5 h-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
          )}
        </div>
        {error?.message && (
          <p className="mt-2 text-sm text-red-600" id="email-error">
            {error.message}
          </p>
        )}
      </div>
    );
  }
);

export default React.memo(Input);
